var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trax-ui-simple-table',{attrs:{"id":_vm.id,"header":_vm.header,"header-color":_vm.headerColor,"titles":_vm.titles,"rows":_vm.rows,"cols":_vm.cols}})
}
var staticRenderFns = []

export { render, staticRenderFns }